import { useState, useEffect } from "react";

const useDeviceDetails = () => {
  const [info, setInfo] = useState({
    isMobile: false,
    isIos: false,
  });
  useEffect(() => {
    setInfo({
      isMobile:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ),
      isIos: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    });
  }, []);

  return { ...info };
};

export default useDeviceDetails;
